
import { RegistrationDataContext } from './Context';
import { useFetchData } from '../../services/useFetchData.service';
import { Spinner } from '../../components/Spinner/Spinner';
import { useEffect, useRef, useState } from 'react';

export const RegistrationDataProvider = ({ children,dataUrl='/Data/Reg2.json' }) => {
  const [data, setData] = useState(null);
  const isLoaded = useRef(false);

  const { data: fetchedData, error: fetchError } = useFetchData(dataUrl);

  useEffect(() => {
    if (isLoaded.current) return;

    if (fetchedData) {
      setData(fetchedData);
      isLoaded.current = true;
    }

    if (fetchError) {
      console.error('Error loading registration data:', fetchError);
    }
  }, [fetchedData, fetchError]);

  if (!data) {
    return <Spinner />;
  }
  return (
    <RegistrationDataContext.Provider value={{ data, setData }}>
      {children}
    </RegistrationDataContext.Provider>
  );
};
